// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
router.beforeEach((to, from, next) => {
  //当移动端试图访问pc端页面时
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) &&
    to.meta.type != "mobile"
  ) {
    const routers = router.options.routes.filter((v) => v.name === "index_m")[0]
      .children;
    let path = "";
    routers.filter((item) => {
      if (item.name.split("_")[1] === to.path.split("_")[1]) {
        path = item.path;
      }
    });
    if (path) {
      next(path);
    } else {
      next("/");
    }
  }
  //当pc端页面试图访问移动端页面时
  if (
    !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) &&
    to.meta.type !== "pc"
  ) {
    const routers = router.options.routes.filter(
      (v) => v.name === "index_pc"
    )[0].children;
    let path = "";
    routers.filter((item) => {
      if (item.name.split("_")[1] === to.path.split("_")[1]) {
        path = item.path;
      }
    });
    if (path) {
      next(path);
    } else {
      next("/");
    }
  }
  next();
});

router.afterEach((to, from, next) => {
  document.querySelector("#app").scrollTo({ top: 0 });
});
import moment from "moment"; //导入文件

Vue.prototype.$moment = moment; //赋值使用

import axiosPlugin from "./server";
Vue.use(axiosPlugin);
//引入外部css
import "./assets/base.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css"; //引入样式

// 中英文切换
import LanguageData from "./language/index";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("languageSet") || "CN",
  CN: LanguageData.CN,
  EN: LanguageData.EN,
});

// 百度地图
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  ak: "Rh3H8v3l6XHYD9kADvnaMU028qVxQOUB",
});

Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  BaiduMap,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js